/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOpexVariantDto } from '../../models/backend-opex-variant-dto';

export interface OpexesVariantsRetrieve$Params {
  id: number;
}

export function opexesVariantsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: OpexesVariantsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendOpexVariantDto>> {
  const rb = new RequestBuilder(rootUrl, opexesVariantsRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendOpexVariantDto>;
    }),
  );
}

opexesVariantsRetrieve.PATH = '/api/opexes/variants/{id}/';
